(function() {
'use strict';

angular
    .module('core')
    .directive('baseMap', baseMap);

function baseMap(maps, broker) {
    // const template = `
    //     <div ng-show="visible" class="hotel-availability-map">
    //         <div class="map-canvas" ng-show="initialized"></div>
    //         <div class="spinner-overlay" ng-class="{'is-complete': initialized}">
    //              <div class="spinner"></div>
    //         </div>
    //     </div>
    // `;

    // TODO template has now become domain specific as TR uses different spinner html.
    // This can be undone when we re-align.

    return {
        restrict: 'E',
        scope: {
            zoom: '@',
            thumbnail: '=',
            visible: '=',
            dealsMode: '@',
            hotelPosition: '=',
            disableUpdates: '@'
        },
        templateUrl: 'partials/home/directivetemplate?type=BaseHotelMap',
        link
    };

    function link(scope, el) {
        let map = null;

        scope.$watch('visible', v => {
            if (!v) { return; }

            maps.loadScript(initializeMap);
        });

        function initializeMap() {
            maps.getLocations(scope.hotelPosition, null, !!scope.dealsMode)
                .then(populateMap);

            if (!scope.disableUpdates) {
                broker.subscribe(
                    'baseMap',
                    'UPDATEMAP',
                    () => maps.getLocations(!!scope.dealsMode).then(populateMap)
                );

                scope.$on('$destroy', () => {
                    broker.unsubscribe('baseMap');
                });
            }
        }


        function populateMap(mapInfo) {
            const canvas = el.find('.map-canvas')[0];
            const center = mapInfo.centre;
            const zoom = parseInt(scope.zoom || 4);

            if (!map) {
                map = maps.buildMap(canvas, center, zoom, null, scope.thumbnail);
            }

            if (mapInfo.markers) {
                if (scope.thumbnail) {
                    let hotelId = scope.thumbnail.activeHotel.Id;
                    let hotelMarker = null;
                    for (let marker of mapInfo.markers) {
                        if (marker.estabId === hotelId) {
                            hotelMarker = marker;
                            break;
                        }
                    }
                    map = maps.buildMap(canvas, null, zoom, hotelMarker, scope.thumbnail);
                    map = maps.addMarkers(map, [hotelMarker]);
                } else {
                    map = maps.addMarkers(map, mapInfo.markers);
                    map.fitBounds(mapInfo.bounds);
                    google.maps.event.addListenerOnce(map, 'idle', () => {
                        map.fitBounds(mapInfo.bounds);
                        if (scope.zoom) {
                            map.setZoom(zoom);
                        }
                    });
                }
            }

            broker.subscribe('baseMap', 'hotelListUpdated', initializeMap);
            broker.subscribe('baseMap', 'mapTabSelected', initializeMap);
            scope.initialized = true;

            /* If the map is hidden and the window is resized we have to build it again */
            google.maps.event.clearListeners(window, 'resize');
        }
    }
}
})();
